import {Divider, Typography, useTheme} from '@mui/material';
import {CopySection, TagChip} from 'presentation/components';
import Icon from 'presentation/icons';
import React from 'react';
import {translations} from 'presentation/translations-new';
import {CopySectionMaskEnum} from 'presentation/constants';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {cardStyleByStatus} from '../../../constants';
import {
	StyledContainerDetail,
	StyledProtocolDate,
	StyledProtocolDateContainer,
	StyledProtocolNumber,
	StyledProtocolNumberDetail,
	StyledRequestInfoDetailCard,
} from './styles';
import {RequestInfoDetailProps} from './types';

const {protocolCopy, requestIn, request, protocol} =
	translations['pt-br'].privateFlow.requestAuthorizations.detail;

export function RequestInfoDetailCard({
	dsSituacao,
	nuControle,
	nuProtocolo,
	dtAutorizacao,
}: RequestInfoDetailProps) {
	const theme = useTheme();

	const {chipText, chipVariant} = cardStyleByStatus(theme, dsSituacao);

	return (
		<StyledRequestInfoDetailCard>
			<StyledContainerDetail>
				<StyledProtocolNumberDetail variant="h6">
					{request}{' '}
					<StyledProtocolNumber variant="label">{nuControle}</StyledProtocolNumber>
				</StyledProtocolNumberDetail>

				<StyledProtocolDateContainer>
					<StyledProtocolDate>
						<Icon color={theme.colors.brand.primary.blue} name="event-filled" />
						<Typography>{`${requestIn} ${dtAutorizacao}`}</Typography>
					</StyledProtocolDate>
					<TagChip label={chipText} color={chipVariant} />
				</StyledProtocolDateContainer>
			</StyledContainerDetail>

			<Divider />

			<StyledContainerDetail>
				<Typography>{protocol}</Typography>
				<CopySection
					mask={CopySectionMaskEnum.WITHOUT_MASK}
					value={nuProtocolo}
					highlightedIcons
					snackbarMessage={protocolCopy}
					dataTagId={{copy: AutoSolEnum.AS_CLICK_COPIAR_PROTOCOLO}}
				/>
			</StyledContainerDetail>
		</StyledRequestInfoDetailCard>
	);
}
